// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + ".0c9f183091d849fc8e98bbcbf3ecb61b.js";
};